import { createSelector } from '@reduxjs/toolkit';

import { CalculatedLine } from '@paragon/contract-library';
import { assertExhaustiveSwitch } from '@paragon/utilities';

import { getReferenceLinesForActiveComponent } from './getReferenceLinesForActiveComponent';
import { getReferenceLineShortNamesByGuidForActiveComponent } from './getReferenceLineShortNamesByGuidForActiveComponentSelector';

export const getReferenceLineLongNamesByGuidForActiveComponent = createSelector(
  getReferenceLinesForActiveComponent,
  getReferenceLineShortNamesByGuidForActiveComponent,
  (referenceLines, shortNamesMap): ReadonlyMap<string, string> | null => {
    if (referenceLines == null || shortNamesMap == null) return null;

    return new Map(
      referenceLines.map((line) => {
        const shortName = shortNamesMap.get(line.guid);
        if (shortName == null) throw new Error('Reference line short name missing.');

        return [line.guid, getReferenceLineLongName(line, shortName)];
      }),
    );
  },
);

function getReferenceLineLongName(line: CalculatedLine, shortName: string) {
  switch (line.lineType) {
    case 'Absolute':
      return shortName;
    case 'Parallel':
      return `${shortName} Parallel`;
    case 'PointSlope':
      return `${shortName} Point Slope`;
    case 'PointToPoint':
      return `${shortName} Point to Point`;
    case 'Perpendicular':
      return `${shortName} Perpendicular`;
    case 'Division':
      return `${shortName} Division`;
    case 'Member':
      return `${shortName} ${line.lineLocation}`;
    default:
      assertExhaustiveSwitch(line, 'Unrecognized line type.');
  }
}
